<template>
  <div
    ref="compContainer"
    class="comp-container comp-container__count"
    :class="{ 'is-filled': inputValue !== null || inputValue === '' }"
    :for="$attrs.id"
  >
    <button
      class="MR-s BDRS-s BGC-light C-light-grey ACTIVE-small"
      :class="{ 'P-s': !mini, 'P-xxs': mini }"
      @click.stop="handleMinus()"
    >
      <span class="material-icons-round VA-m">remove</span>
    </button>
    <input
      class="P-xxs BDRS-s TA-c C-dark FW-b"
      inputmode="numeric"
      aria-label="count"
      type="number"
      :class="{ 'BGC-brand': inputValue, 'BGC-light': !inputValue, 'is-mini': mini }"
      :readonly="readonly"
      @keypress="onlyNumber($event)"
      @input="inputValHandler($event)"
      @blur="inputBlurHandler()"
      @touchstart="inputTouchStartHandler($event)"
      @compositionstart="inputValue = ''"
      v-bind="$attrs"
      v-model.number="inputValue"
    />
    <button
      class="ML-s BDRS-s BGC-light C-light-grey ACTIVE-small"
      :class="{ 'P-s': !mini, 'P-xxs': mini }"
      @click.stop="handleAdd()"
    >
      <span class="material-icons-round VA-m">add</span>
    </button>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: null,
    min: null,
    max: null,
    mini: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: null,
    };
  },
  mounted() {
    this.inputValue = this.value;
  },
  methods: {
    onlyNumber(event) {
      const { key } = event;

      if (
        key !== '0'
        && key !== '1'
        && key !== '2'
        && key !== '3'
        && key !== '4'
        && key !== '5'
        && key !== '6'
        && key !== '7'
        && key !== '8'
        && key !== '9'
      ) {
        event.preventDefault();
      }
    },
    inputValHandler() {
      if (this.inputValue === '') {
        this.inputValue = '';
        return;
      }

      if (this.max != null && this.max < Number(this.inputValue)) {
        this.$root.$message.error(this.$i18n.t('count.cannotIncrease'));
        this.inputValue = this.max;
      } else if (this.min != null && Number(this.inputValue) < this.min) {
        this.$root.$message.error(this.$i18n.t('count.cannotDecrease'));
        this.inputValue = this.min;
      }

      this.$emit('updateCount', this.inputValue);
    },
    inputBlurHandler() {
      if (this.inputValue === '') {
        this.inputValue = this.min;
        this.$emit('updateCount', this.inputValue);
      }
    },
    inputTouchStartHandler(event) {
      if (this.readonly) {
        event.preventDefault();
      }
    },
    handleAdd() {
      if (this.max != null && this.max <= Number(this.inputValue)) {
        this.$root.$message.error(this.$i18n.t('count.cannotIncrease'));
        return;
      }
      this.inputValue = Number(this.inputValue) + 1;
      this.$emit('updateCount', this.inputValue);
    },
    handleMinus() {
      if (this.min != null && this.min >= Number(this.inputValue)) {
        this.$root.$message.error(this.$i18n.t('count.cannotDecrease'));
        return;
      }

      this.inputValue = Number(this.inputValue) - 1;
      this.$emit('updateCount', this.inputValue);
    },
  },
};
</script>

<style lang="sass" scoped>
.comp-container__count
  display: flex
  align-items: center

button
  border: none

  appearance: none
  outline: none

  &:active
    @extend .BGC-light-grey
    @extend .C-dark

    outline: 0

input
  width: $size-xxl
  height: $size-xxl
  border: none

  appearance: none
  -webkit-appearance: none

  &:focus
    outline: 0

  &.is-mini
    width: $size-xl
    height: $size-xl

input[type=number]::-webkit-inner-spin-button, [type=number]::-webkit-outer-spin-button
  -webkit-appearance: none
  margin: 0

</style>
